// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sl_5e{margin-block-end:16px}.UFR5z{display:flex;align-items:center;width:100%;padding:12px 16px;border:1px solid var(--text-on-standard-bg, #d4d4e0);border-radius:8px;background-color:transparent;cursor:pointer;text-align:left;font:inherit}.UFR5z[data-error=true]{border-color:var(--red-700, #f3aaaa)}.SW7zR{margin-top:4px}.PL7T5{min-height:0}.Iwh09{background-color:transparent !important}.Iwh09 .MuiMenuItem-root{color:var(--text-on-standard-bg, var(--text-standard)) !important}.ALC58{background-color:transparent !important}.ALC58 .MuiMenuItem-root{color:var(--text-on-standard-bg, var(--text-standard)) !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContent": `Sl_5e`,
	"roleSelector": `UFR5z`,
	"errorText": `SW7zR`,
	"actionsMenu": `PL7T5`,
	"actionsMenuRoot": `Iwh09`,
	"roleSelectionMenu": `ALC58`
};
export default ___CSS_LOADER_EXPORT___;
